export default __webpack_public_path__ + "static/media/PAFI_Riwayat Hidup Calon Anggota Direksi 2023.34ad7e33.pdf";